/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, February 2026
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import SpecifiedAttachmentsPanel from '../../components/SpecifiedAttachmentsPanel/SpecifiedAttachmentsPanel';
import { connect } from 'react-redux';
import { runService, saveValidators } from '../../actions/eservices';
import { isMobileView, isTabletView, renderHelpDesc, isSuperAdminRole } from '../../components/utils/utils';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import loadingData from './loading';
import { infoDict, InitialAttachmentsDict, btnStyle, bodyStyle, redirectToSummary } from './constants';
import { trackEvent } from '../../lib/utils';
import ButtonsPanel from './utils/ButtonsPanel';
import waiting from '../paymentStatus/waiting-wheel-300x300.gif';
import { showDraftsCondition, saveDraft, areEqual, getDraft, getDraftDataFromState } from '../../components/DraftManagement/draftManager';

import v from './validators';


const stateToDraft = [
  "info",
  "selectedParcels",
  "selectedRoads",
  "attachments",
];


class UsuniecieDrzewGminnych extends React.Component {
  state = {
    info: {
      miejscowosc: null,
      przeznaczenie: null,
      przyczyna: null,
      termin: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachmentsDict: InitialAttachmentsDict[this.props.serviceInfo.eservice.shortName] || {},
    attachments: null,
    draftAttachments: null,
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
    showDrafts: false,
  };

  validators = {
    miejscowosc: [v.NotNull],
    przeznaczenie: [v.NotNull],
    przyczyna: [v.NotNull],
    termin: [v.NotNull, v.CheckDate],
  };

  async componentDidMount() {
    const showDrafts = showDraftsCondition(this.props.prefix);
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
          showDrafts: showDrafts,
        });
      });

    if (showDrafts) {
      const draftData = await getDraft(this.props.prefix, this.props.serviceInfo.eservice.shortName);

      if (draftData) {
        this.setState({ ...draftData, draftAttachments: draftData.attachments, isMounted: true }, () => {
          window.dispatchEvent(
            new CustomEvent("draft:loaded")
          );
        });
      } else {
        this.setState({ isMounted: true });
      }
    } else {
      this.setState({
        isMounted: true
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showDrafts) {
      if (!this.state.isMounted) return;

      if (!prevState.isMounted && this.state.isMounted) return;

      const prevDraft = getDraftDataFromState(prevState, stateToDraft);
      const currentDraft = getDraftDataFromState(this.state, stateToDraft);

      if (this.props.serviceInfo.user && !areEqual(prevDraft, currentDraft)) {
        saveDraft(
          currentDraft,
          this.props.prefix,
          this.props.serviceInfo.eservice.shortName
        );
      }
    }
  }

  handleManualDraftSave = () => {
    const draft = getDraftDataFromState(this.state, stateToDraft);

    saveDraft(
      draft,
      this.props.prefix,
      this.props.serviceInfo.eservice.shortName,
      { debounce: false } // wymuszony zapis
    );
  };

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        miejscowosc: 'Miejscowość testowa',
        przeznaczenie: 'Przeznaczenie testowe',
        przyczyna: 'Przczyna testowa',
        termin: '12.12.2026',
      },
    });
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      return this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
    }

    if (hasFieldErrors) {
      return this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      return this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      return this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          info: { ...this.state.info },
          user: {
            ...this.props.serviceInfo.user,
          },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () => {
              trackEvent({
                category: 'application',
                action: 'click',
                name: this.props.serviceInfo.eservice.title,
              });
              redirectToSummary(resp.jobId);
            }
          );
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);

    if (!this.state.isMounted) {
      return (
        <GrayPanel
          title="Trwa ładowanie zawartości..."
          bodyStyle={bodyStyle}
        >
          <img alt="Loader" src={waiting} />
        </GrayPanel>
      );
    }

    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <GrayPanel
          title={'1. Teren'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
            treeSelection
            showPdfExport
          />
        </GrayPanel>

        <DecisionContainer
          title={'2. Informacje dodatkowe'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={infoDict[this.props.serviceInfo.eservice.shortName] || {}}
          onChange={e => this.onChange(e, 'info')}
        />

        <SpecifiedAttachmentsPanel
          attachmentsDict={this.state.attachmentsDict}
          onChangeAttachments={this.onChangeAttachments}
          showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}
          draftAttachments={this.state.draftAttachments}
        />
        
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <ButtonsPanel
          prefix={this.props.prefix}
          shortName={this.props.serviceInfo.eservice.shortName}
          serviceTitle={this.props.serviceInfo.eservice.title}
          showDrafts={this.state.showDrafts}
          onDraftSave={this.handleManualDraftSave}
          onSave={() => this.setState({ loading: true }, () => this.startService())}
          onCancel={history.goBack}
        />

        <div className="col-sm-12" style={{ paddingLeft: '0px' }}>
          {(this.props.serviceInfo.user && isSuperAdminRole(this.props.serviceInfo.user.roles)) ? (
            <button
              type="submit-lg"
              className="btn btn-success"
              style={{ float: 'left', ...btnStyle }}
              onClick={this.insertTestData}
            >
              Insert Test Data
            </button>
          ) : null}
        </div>
      </div>
    );
  }
}

UsuniecieDrzewGminnych.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
  saveValidators,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(UsuniecieDrzewGminnych),
);



// WEBPACK FOOTER //
// src/routes/eservices/UsuniecieDrzewGminnych.js